import { CategoryBreadcrumb } from '@corratech/pylot-breadcrumbs'
import { CmsPage } from '@pylot-data/pylotschema'
import { useMemo } from 'react'

const CMS_PARENTS = [
    {
        category_name: 'Inspírate',
        category_url_key: 'inspirate',
        category_url_path: 'inspirate',
        category_url_prefix: '/contenido'
    },
    {
        category_name: 'Sostenibilidad',
        category_url_key: 'sostenibilidad',
        category_url_path: 'sostenibilidad',
        category_url_prefix: '/contenido'
    }
]

type CmsCategoryContentBreadcrumb = CategoryBreadcrumb & {
    category_url_prefix: string
}

type CmsBreadcrumbsData = {
    name: string
    breadcrumbs: CmsCategoryContentBreadcrumb[]
    urlPrefix: string
}

const useCmsBreadcrumbs = (
    cmsPageData: CmsPage | null | undefined
): CmsBreadcrumbsData | undefined => {
    const breadcrumbsData = useMemo(() => {
        if (!cmsPageData) return
        const { title, url_key: url } = cmsPageData
        const parent = (url?.includes('/') && url?.split('/')?.[0]) || ''
        const breadcrumbs = CMS_PARENTS.filter(
            (breadcrumb) => breadcrumb.category_url_key === parent
        )

        return {
            name: title || '',
            breadcrumbs,
            urlPrefix: breadcrumbs[0]?.category_url_prefix || ''
        }
    }, [cmsPageData])

    return breadcrumbsData
}

export { useCmsBreadcrumbs }
